export class DatahubLayer {
    constructor() {
        this.action = '';
        this.theme = '';
        this.name = '';
        this.alias = '';
        this.fields = [];
        this.description = '';
    }
}
/**
 * DatahubSelection is used internally to communicate with the datahub iframe.
 * Please use DatahubLayer outside of this component.
 */
export class DatahubSelection {
    constructor() {
        this.action = '';
        this.theme = '';
        this.layer = '';
        this.fields = [];
        this.dataId = '';
        this.description = '';
    }
}
export class DatahubField {
    constructor() {
        this.name = '';
        this.alias = '';
    }
}
